(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faqs"] && !Shopify.designMode) return;
  try {
    
  // Find every accordion row rendered by this section.
  document.querySelectorAll('.ej-collection-faqs__item').forEach(function (item) {
    // When a row is opened...
    item.addEventListener('toggle', function () {
      if (item.open) {
        // ...close every OTHER row so only one stays open at a time.
        item.parentElement
          .querySelectorAll('.ej-collection-faqs__item[open]')
          .forEach(function (other) {
            if (other !== item) other.open = false;
          });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
    var banner = document.querySelector('[data-sale-banner]');
    var headerEl = document.querySelector('[data-header-height]');
    var navRow = document.querySelector('[data-collection-tools]');
    var footerEl = document.querySelector('footer.footer') || document.querySelector('footer');
    if (!banner || !headerEl) return;

    var ticking = false;
    var footerVisible = false;

    if (footerEl) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
        });
        onScrollOrResize();
      }, { threshold: 0 });
      footerObserver.observe(footerEl);
    }

    function update() {
      var headerBottom = headerEl.getBoundingClientRect().bottom;
      if (headerBottom <= 0 || headerBottom > 160) {
        headerBottom = 100;
      }

      var bannerTop = headerBottom;
      if (navRow && window.innerWidth <= 479) {
        var navBottom = navRow.getBoundingClientRect().bottom;
        if (navBottom > headerBottom && navBottom <= 250) {
          bannerTop = navBottom;
        }
      }
      banner.style.top = bannerTop + 'px';
      banner.classList.toggle('is-visible', window.scrollY > 220 && !footerVisible);
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('orientationchange', onScrollOrResize);
  })();

  // ITEM [NEW v2] — Mobile filter accordions: auto-expand when the drawer opens (mobile only, desktop untouched).
  // Fires the moment the shopper taps the actual "open filters" button — a real event, not a timing guess.
  // Runs once per page view — if the shopper manually collapses a category afterward, we leave it alone.
  (function () {
    var hasAutoExpanded = false;

    function openMobileFilterAccordions() {
      var breakpoint = (window.theme && window.theme.sizes) ? window.theme.sizes.medium : 768;
      if (window.innerWidth >= breakpoint) return; // desktop/tablet — leave filters exactly as they are
      if (hasAutoExpanded) return; // already handled this page view — don't fight manual collapses later
      hasAutoExpanded = true;

      var triggers = document.querySelectorAll('.collection__filters__wrapper [data-accordion-trigger]');
      triggers.forEach(function (trigger) {
        if (trigger.classList.contains('accordion-is-open')) return; // already open, skip
        trigger.click(); // reuses the theme's own open/animate logic
      });
    }

    function attachDrawerOpenListener() {
      // Only the button that OPENS the filter drawer. The drawer's own Close (X) button
      // carries this same data-filters-toggle="filters" attribute, so we scope to the
      // specific open-toggle class to avoid firing this when the drawer is closed.
      var openButtons = document.querySelectorAll('.collection__filters__toggle[data-filters-toggle]');
      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          window.setTimeout(openMobileFilterAccordions, 50);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachDrawerOpenListener);
    } else {
      attachDrawerOpenListener();
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.mobileSearchInit) return;
    window.mobileSearchInit = true;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-search-toggle]');
      if (!toggle) return;
      e.preventDefault();

      var panel = document.querySelector('[data-mobile-inline-search]');
      if (!panel) return;

      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) {
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
          input.focus();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
